import { render, staticRenderFns } from "./authSubTitle.vue?vue&type=template&id=3262ec9e&"
import script from "./authSubTitle.vue?vue&type=script&lang=js&"
export * from "./authSubTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports